import { createAction } from 'redux-act'

export const LOGIN_START = createAction('LOGIN_START', (id, password) => ({ id, password }));
export const LOGIN_COMPLETE = createAction('LOGIN_IN_COMPLETE');
export const LOGIN_ERROR = createAction('LOGIN_ERROR');
export const LOG_OUT = createAction('LOGOUT');
